import React from "react";

// reactstrap components
import {Col, Container, Row, Progress} from "reactstrap";

function SkillsCard() {

    return (
        <>
            <div className="section text-center">
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            <h2 className="title">Skills</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">JavaScript</span>
                                <Progress
                                    max="100"
                                    value="85"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">Ruby on Rails</span>
                                <Progress
                                    max="100"
                                    value="77"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">Python</span>
                                <Progress
                                    max="100"
                                    value="65"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">PHP</span>
                                <Progress
                                    max="100"
                                    value="65"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">MySQL</span>
                                <Progress
                                    max="100"
                                    value="85"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                        </Col>
                        <Col>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">Leadership</span>
                                <Progress
                                    max="100"
                                    value="87"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">Team Management</span>
                                <Progress
                                    max="100"
                                    value="95"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">Agile Methodologies</span>
                                <Progress
                                    max="100"
                                    value="98"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">Release Management</span>
                                <Progress
                                    max="100"
                                    value="90"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                            <div className="progress-container progress-danger text-left">
                                <span className="progress-badge">Project Management</span>
                                <Progress
                                    max="100"
                                    value="95"
                                    barClassName="progress-bar-warning"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default SkillsCard;
